import { Layout } from "@/app/layout"
import { AuthPage } from "@/pages/auth"
import { CompanyRegistrationPage } from "@/pages/company-registration"
import { CompanyProfilePage } from "@/pages/company-profile"
import { AviabookingPage } from "@/pages/aviabooking"
import { BookFlightPage } from "@/pages/aviabooking-book-flight"
import { AviabookingBookingsPage } from "@/pages/aviabooking-bookings"
import { BonusListPage } from "@/pages/bonus-list"
import { BonusProcessingTransactionsPage } from "@/pages/bonus-processing-transactions"
import { BonusReportsPage } from "@/pages/bonus-reports"
import { BonusTransactionPage } from "@/pages/bonus-transaction"
import { BonusTransactionsPage } from "@/pages/bonus-transactions"
import { PartnerAccrualsPage } from "@/pages/partner-accruals"
import { BusinessCardsPage } from "@/pages/business-cards"
import { BusinessCardDetailsPage } from "@/pages/business-card-details"
import { CreateMarketingCampaignPage } from "@/pages/create-marketing-campaign"
import { EmployeesGroupsPage } from "@/pages/employees-groups"
import { EmployeesInvitationsPage } from "@/pages/employees-invitations"
import { EmployeesListPage } from "@/pages/employees-list"
import { EmployeesProfilebuilderPage } from "@/pages/employees-profilebuilder"
import { EmploymentPage } from "@/pages/employment"
import { FoundationsPage } from "@/pages/foundations"
import { InvoicesPage } from "@/pages/invoices"
import { MainPage } from "@/pages/main"
import { MarketingCampaignPage } from "@/pages/marketing-campaign"
import { MarketingCampaignAnnouncePage } from "@/pages/marketing-campaign-announce"
import { MarketingCampaignsPage } from "@/pages/marketing-campaigns"
import { MarketingCampaignsReportPage } from "@/pages/marketing-campaigns-report"
import { NotFoundPage } from "@/pages/not-found"
import { NotificationsPage } from "@/pages/notifications"
import { PartnerDiscountsPage } from "@/pages/partner-discounts"
import { PartnerMapPage } from "@/pages/partner-map"
import { PartnerStoresPage } from "@/pages/partner-stores"
import { PartnerTransactionPage } from "@/pages/partner-transaction"
import { PartnerTransactionsPage } from "@/pages/partner-transactions"
import { SettingsPage } from "@/pages/settings"
import { PhoneWhitelistPage } from "@/pages/phone-whitelist"
import { AclPage } from "@/pages/acl"
import { AdminActionsPage } from "@/pages/admin-actions"
import { PartnerApiCallsPage } from "@/pages/partner-api-calls"
import { SectionGate } from "@/entities/community-sections-availability"
import { LoyaltyAccrualsPage } from "@/pages/loyalty-accruals"
import { LoyaltyLevelsPage } from "@/pages/loyalty-levels"
import { LoyaltyReportsPage } from "@/pages/loyalty-reports"
import { LoyaltyStatisticsPage } from "@/pages/loyalty-statistics"
import { RestaurantMenuDetailPage } from "@/pages/restaurant-menu-detail"
import { RestaurantMenuOrdersPage } from "@/pages/restaurant-menu-orders"
import { RestaurantMenuStatisticsPage } from "@/pages/restaurant-menu-statistics"
import { RestaurantMenusPage } from "@/pages/restaurant-menus"
import { PromotionsPage } from "@/pages/promotions"
import { SocialMarketPage } from "@/pages/social-market"
import { SocialMarketFoundationsPage } from "@/pages/social-market-foundations"
import { SocialMarketPairPage } from "@/pages/social-market-pair"
import { SocialMarketPartnerPage } from "@/pages/social-market-partner"
import { SocialMarketPartnersPage } from "@/pages/social-market-partners"
import { SocialMarketTransactionPage } from "@/pages/social-market-transactions"
import { SocialProgramsPage } from "@/pages/social-programs"
import { SocialProgramDetailPage, SocialProgramGroupsDetailPage, SocialProgramWalletPage } from "@/pages/social-program-detail"
import { UserProfilePage } from "@/pages/user-profile"
import { UsersGroupsPage } from "@/pages/users-groups"
import { UsersInvitationsPage } from "@/pages/users-invitations"
import { UsersCreationPage } from "@/pages/users-creation"
import { UsersAttractedPage } from "@/pages/users-attracted"
import { UsersListPage } from "@/pages/users-list"
import { UsersProfilebuilderPage } from "@/pages/users-profilebuilder"
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom"
import { lazy, Suspense } from "react"
import { Loader } from "@/shared/ui/loader"

// Единственный ленивый маршрут в приложении: рендерер документации тянет
// swagger-ui-react вместе с его собственным CSS, и в общем чанке эта цена
// легла бы на каждого администратора, включая тех, кто раздел не открывает.
const PartnerApiDocsPage = lazy(() => import("@/pages/partner-api-docs")
    .then((module) => ({ default: module.PartnerApiDocsPage })))

const router = createBrowserRouter([
    {
        path: '/',
        element: <Layout />,
        children: [
            {
                path: '/',
                element: <MainPage />
            },
            {
                path: '/bonuses/list',
                element: <BonusListPage />
            },
            {
                path: '/bonuses/invoices',
                element: <InvoicesPage />
            },
            {
                path: '/bonuses/transactions',
                element: <BonusTransactionsPage />
            },
            {
                path: '/bonuses/processing-transactions',
                element: <BonusProcessingTransactionsPage />
            },
            {
                path: '/bonuses/transactions/:id',
                element: <BonusTransactionPage />
            },
            {
                path: '/bonuses/reports',
                element: <BonusReportsPage />
            },
            {
                path: '/bonuses/accruals',
                element: <PartnerAccrualsPage />
            },
            {
                path: '/foundations',
                element: <FoundationsPage />
            },
            {
                path: '/employment',
                element: <EmploymentPage />
            },
            {
                path: '/partner/stores',
                element: <PartnerStoresPage />
            },
            {
                path: '/partner/transactions',
                element: <PartnerTransactionsPage />
            },
            {
                path: '/partner/transactions/:id',
                element: <PartnerTransactionPage />
            },
            {
                path: '/partner/discounts',
                element: <PartnerDiscountsPage />
            },
            {
                path: '/partner/map',
                element: <PartnerMapPage />
            },
            {
                path: '/users/list',
                element: <UsersListPage />
            },
            {
                path: '/users/attracted',
                element: <UsersAttractedPage />
            },
            {
                path: '/users/profilebuilder',
                element: <UsersProfilebuilderPage />
            },
            {
                path: '/users/groups',
                element: <UsersGroupsPage />
            },
            {
                path: '/users/invitations',
                element: <UsersInvitationsPage />
            },
            {
                path: '/users/creation',
                element: <UsersCreationPage />
            },
            {
                path: '/users/profile/:id',
                element: <UserProfilePage />
            },
            {
                path: '/employees/list',
                element: <EmployeesListPage />
            },
            {
                path: '/employees/invitations',
                element: <EmployeesInvitationsPage />
            },
            {
                path: '/employees/groups',
                element: <EmployeesGroupsPage />
            },
            {
                path: '/employees/profilebuilder',
                element: <EmployeesProfilebuilderPage />
            },
            {
                path: '/social-programs',
                element: <SocialProgramsPage />
            },
            {
                path: '/social-programs/:id',
                element: <SocialProgramDetailPage />
            },
            {
                path: '/social-programs/:id/groups',
                element: <SocialProgramGroupsDetailPage />
            },
            {
                path: '/social-programs/:id/wallet',
                element: <SocialProgramWalletPage />
            },
            {
                path: '/social-market',
                element: <SocialMarketPage />
            },
            {
                path: '/social-market/transactions',
                element: <SocialMarketTransactionPage />
            },
            {
                path: '/social-market/pair/:id',
                element: <SocialMarketPairPage />
            },
            {
                path: '/social-market/partners/:id',
                element: <SocialMarketPartnerPage />
            },
            {
                path: '/social-market/partners',
                element: <SocialMarketPartnersPage />
            },
            {
                path: '/social-market/foundations',
                element: <SocialMarketFoundationsPage />
            },
            {
                path: '/social-market/pair/:id',
                element: <SocialMarketPairPage />
            },
            {
                path: '/notifications',
                element: <NotificationsPage />
            },
            {
                path: '/settings',
                element: <SettingsPage />
            },
            {
                path: '/company-profile',
                element: <CompanyProfilePage />
            },
            {
                path: '/marketing-campaigns',
                element: <MarketingCampaignsPage />
            },
            {
                path: '/promotions',
                element: <PromotionsPage />
            },
            {
                path: '/loyalty-levels',
                element: (
                    <SectionGate section="loyalty_levels">
                        <Navigate to="/loyalty-levels/settings" replace />
                    </SectionGate>
                )
            },
            {
                path: '/loyalty-levels/settings',
                element: (
                    <SectionGate section="loyalty_levels">
                        <LoyaltyLevelsPage />
                    </SectionGate>
                )
            },
            {
                path: '/loyalty-levels/statistics',
                element: (
                    <SectionGate section="loyalty_levels">
                        <LoyaltyStatisticsPage />
                    </SectionGate>
                )
            },
            {
                path: '/loyalty-levels/accruals',
                element: (
                    <SectionGate section="loyalty_levels">
                        <LoyaltyAccrualsPage />
                    </SectionGate>
                )
            },
            {
                path: '/loyalty-levels/reports',
                element: (
                    <SectionGate section="loyalty_levels">
                        <LoyaltyReportsPage />
                    </SectionGate>
                )
            },
            {
                path: '/restaurant-menus',
                element: (
                    <SectionGate section="restaurant_menus">
                        <Navigate to="/restaurant-menus/settings" replace />
                    </SectionGate>
                )
            },
            {
                path: '/restaurant-menus/settings',
                element: (
                    <SectionGate section="restaurant_menus">
                        <RestaurantMenusPage />
                    </SectionGate>
                )
            },
            {
                path: '/restaurant-menus/statistics',
                element: (
                    <SectionGate section="restaurant_menus">
                        <RestaurantMenuStatisticsPage />
                    </SectionGate>
                )
            },
            {
                path: '/restaurant-menus/orders',
                element: (
                    <SectionGate section="restaurant_menus">
                        <RestaurantMenuOrdersPage />
                    </SectionGate>
                )
            },
            {
                path: '/restaurant-menus/:menuId',
                element: (
                    <SectionGate section="restaurant_menus">
                        <RestaurantMenuDetailPage />
                    </SectionGate>
                )
            },
            {
                path: '/marketing-campaigns/create',
                element: <CreateMarketingCampaignPage />
            },
            {
                path: '/marketing-campaigns/reports',
                element: <MarketingCampaignsReportPage />
            },
            {
                path: '/marketing-campaigns/campaign/:id',
                element: <MarketingCampaignPage />
            },
            {
                path: '/avia-booking',
                element: <AviabookingPage />
            },
            {
                path: '/avia-booking/flights/:id/book',
                element: <BookFlightPage />
            },
            {
                path: '/avia-booking/bookings',
                element: <AviabookingBookingsPage />
            },
            {
                path: '/marketing-campaigns/campaign/:id/announce',
                element: <MarketingCampaignAnnouncePage />
            },
            {
                path: '/business-cards',
                element: <BusinessCardsPage />
            },
            {
                path: '/business-cards/:id',
                element: <BusinessCardDetailsPage />
            },
            {
                path: '/security/whitelist',
                element: <PhoneWhitelistPage />
            },
            {
                path: '/security/acl',
                element: <AclPage />
            },
            {
                path: '/security/admin-actions',
                element: <AdminActionsPage />
            },
            {
                path: '/security/partner-api-calls',
                element: <PartnerApiCallsPage />
            },
            {
                path: '/security/partner-api-docs',
                element: (
                    <Suspense fallback={
                        <div className="_page_container flex min-h-24 items-center justify-center">
                            <Loader />
                        </div>
                    }>
                        <PartnerApiDocsPage />
                    </Suspense>
                )
            },
        ],
    },
    {
        path: '/auth',
        element: <AuthPage />
    },
    {
        path: '/company-registration',
        element: <CompanyRegistrationPage />
    },
    {
        path: '/404',
        element: <NotFoundPage />
    },
    {
        path: '*',
        element: <NotFoundPage />
    }
])

export const AppRouter = () => {
    return (
        <RouterProvider router={router}/>
    )
}
